import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ServiceList from "./ServiceList";
import ServiceFilter from "../../elements/services/ServiceFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import Notification from "../../elements/notification/Notification";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { removeTransferFromCollection } from "../../../utils/collections";
import { useTranslation } from "react-i18next";
import MaterialPagination from "../../styles/materialPagination";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledServicesWrapper } from "../styledServices";

const ServicesContainer = () => {
  const { t } = useTranslation("servicePage");
  const [services, setServices] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "name": checkFilterItem(history, "name", null),
    "nickname": checkFilterItem(history, "nickname", null)
  });
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchServicesList = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/services" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setServices(removeTransferFromCollection(response.data["hydra:member"]));
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchServicesList();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledServicesWrapper>
          <ServiceFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ServiceList
            services={services}
            fetchServicesList={fetchServicesList}
            notification={notification}
            setNotification={setNotification}
          />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledServicesWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default ServicesContainer;